import { IS_LOADING, ERROR} from "../../constants";

export { IS_LOADING, ERROR }

export const COMPONENT_SEARCH_HAS_ERRORED = 'COMPONENT_SEARCH_HAS_ERRORED';
export const COMPONENT_SEARCH_IS_LOADING = 'COMPONENT_SEARCH_IS_LOADING';
export const COMPONENT_SEARCH = 'COMPONENT_SEARCH';
export const CLEAR_COMPONENT_SEARCH = 'CLEAR_COMPONENT_SEARCH';
export const SET_INPUT_SEARCH = 'SET_INPUT_SEARCH';
export const SET_SELECTED_TAB = 'SET_SELECTED_TAB';

export const GET_PARKS = "GET_PARKS";
export const SET_CURRENT_PARK = "SET_CURRENT_PARK";
export const SET_CURRENT_COMPONENT = "SET_CURRENT_COMPONENT";